import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import ColorOptions from 'helpers/types';
import { useHubSpotFormInjection } from './hooks/useHubSpotFormInjection';
import { useHubSpotCheckboxGroups } from './hooks/useHubSpotCheckboxGroups';
import { useReactSelectPortals } from './hooks/useReactSelectPortals';
import { useHubSpotButtonStyles } from './hooks/useHubSpotButtonStyles';
import { useHubSpotFullWidth } from './hooks/useHubSpotFullWidth';

export interface HubSpotFormProps {
	formHtmlCode: string;
	className?: string;
	displayButtonRight?: boolean;
	inputFullWidth?: boolean;
	selectAllLabel?: string;
	placeholderLabel?: string;
	buttonStyle?: 'primary' | 'secondary';
	bgColor?: ColorOptions;
	kicker?: { firstWord?: string; secondWord?: string };
	showImage?: boolean;
	layoutType?: string;
}

const HubSpotForm: React.FC<HubSpotFormProps> = ({
	formHtmlCode,
	className,
	displayButtonRight,
	inputFullWidth,
	selectAllLabel = 'Select All',
	placeholderLabel = 'Select...',
	buttonStyle = 'primary',
	bgColor,
}) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	useHubSpotFormInjection(containerRef, formHtmlCode, isMounted);
	const checkboxGroups = useHubSpotCheckboxGroups(containerRef, formHtmlCode, selectAllLabel, isMounted);
	const reactSelectPortals = useReactSelectPortals(containerRef, checkboxGroups, placeholderLabel, isMounted);
	useHubSpotButtonStyles(containerRef, formHtmlCode, buttonStyle, isMounted);
	useHubSpotFullWidth(containerRef, formHtmlCode, inputFullWidth, isMounted);

	if (!isMounted) {
		return null;
	}

	return (
		<div
			className={classNames(
				className,
				'hubspot',
				`hubspot_Button___${buttonStyle}`,
				{ hubspot_displayButtonRight: displayButtonRight },
				{ hubspot_inputFullWidth: inputFullWidth },
				`u-color___${bgColor}`,
			)}
		>
			<div ref={containerRef} />
			{reactSelectPortals}
		</div>
	);
};

export default HubSpotForm;
